import waitForLoad from "../utils/waitForLoad";
var domain = 'https://widget.intercom.io';
/* eslint-disable */
var loadScript = function loadScript(appId) {
  if (window.Intercom) return false;
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', window.intercomSettings);
    } else {
      var d = document;
      var _i = function i() {
        _i.c(arguments);
      };
      _i.q = [];
      _i.c = function (args) {
        _i.q.push(args);
      };
      w.Intercom = _i;
      var l = function l() {
        var _x$parentNode;
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = "".concat(domain, "/widget/").concat(appId);
        var x = d.getElementsByTagName('script')[0];
        (_x$parentNode = x.parentNode) === null || _x$parentNode === void 0 || _x$parentNode.insertBefore(s, x);
      };
      l();
    }
  })();
  return true;
};
/* eslint-enable */

var load = function load(_ref) {
  var providerKey = _ref.providerKey,
    setState = _ref.setState,
    _ref$beforeInit = _ref.beforeInit,
    beforeInit = _ref$beforeInit === void 0 ? function () {
      return undefined;
    } : _ref$beforeInit,
    _ref$onReady = _ref.onReady,
    onReady = _ref$onReady === void 0 ? function () {
      return undefined;
    } : _ref$onReady;
  var loaded = loadScript(providerKey);

  // Continue as long as userlike hasn’t already been initialised.
  if (loaded) {
    beforeInit();
    window.Intercom('boot', {
      app_id: providerKey
    });
    waitForLoad(function () {
      return window.Intercom.booted;
    },
    // Allow intercom to complete loading before removing fake widget
    function () {
      return setTimeout(function () {
        setState('complete');
        onReady();
      }, 2000);
    });
  }
  return loaded;
};
var open = function open() {
  return window.Intercom('show');
};
export default {
  domain: domain,
  load: load,
  open: open
};